module.exports = __webpack_public_path__ + "static/profil_indywidualne-b126b3535cdac2614fb98863477a5ab6.jpg";